import React from 'react';

import Button from '@material-ui/core/Button';
import Save from '@material-ui/icons/Save';

const DisabledSaveButton = () => (
  <Button variant="raised" color="primary" disabled={true} style={{ margin: '10px 24px', position: 'relative' }}>Save<Save /></Button>
);

export default DisabledSaveButton;



// WEBPACK FOOTER //
// ./src/views/Common/Buttons/DisabledSave.tsx